import { render, staticRenderFns } from "./ClientSelector.vue?vue&type=template&id=6b3ae6e2&scoped=true"
import script from "./clientSelector.ts?vue&type=script&lang=ts&external"
export * from "./clientSelector.ts?vue&type=script&lang=ts&external"
import style0 from "./ClientSelector.vue?vue&type=style&index=0&id=6b3ae6e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3ae6e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b3ae6e2')) {
      api.createRecord('6b3ae6e2', component.options)
    } else {
      api.reload('6b3ae6e2', component.options)
    }
    module.hot.accept("./ClientSelector.vue?vue&type=template&id=6b3ae6e2&scoped=true", function () {
      api.rerender('6b3ae6e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/shared/explore/top-filter/client-selector/ClientSelector.vue"
export default component.exports